<template>
  <div class="cashier">
    <van-nav-bar
      title="结算台"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
    <div class="top">
      <p class="money"><span>￥{{$route.query.money}}</span></p>
      
      <!-- <p>订单已提交，请您尽快支付</p> -->
      <p v-show="this.$route.query.sid">本单超过24小时未结算或未付款将会取消！</p>
      <!-- <p >本单超过24小时未结算或未付款将会取消！</p> -->

      <p v-show="!this.$route.query.sid">超级会员费用请联系业务员付款</p>  
      <div class="img">
        <van-icon
          name="passed"
          size="1rem"
          color="#a53533"
        />
      </div>
    </div>
    <div class="bottom">
      <div class="title">请选择结算方式</div>
      <ul class="conten">
       <!-- <li v-show="uid==7360 || uid==8168 ||  uid==148|| uid==96" class="clearfix"  >
          <div class="fan">
<van-checkbox :disabled='checked1' @click="fan" v-model="checked"></van-checkbox>

          </div>
          <div class="fans"
        
          >
          <img           
            src="../../assets/f1.png"
            alt=""
          >
          <p>钱包扣划</p>
          <p class="p2">钱包余额：<br> ￥{{yu}}</p>
          </div>
           
        </li> -->
         <!-- <li v-show="uid==7360 || uid==8168 ||  uid==148|| uid==96|| uid==12343" class="clearfix" > -->
          <li v-show="[1,19,22,51,56].indexOf(this.$route.query.sid)!= -1" class="clearfix" >
                  <div class="fan">
<van-checkbox :disabled='checked4' @click="fan2" v-model="checked2"></van-checkbox>
          </div>
          <div class="fans">
 <img            
            src="../../assets/f2.png"
            alt=""
          >
          <p>信用赊欠 </p>
          <p class="p2">鲸信用余额：<br> ￥{{yu2}}</p>
          </div>
          
        </li>
        <li
          class="clearfix"
         @click="xarr"
          v-for="(v,i) in list"
          :key="v.type"
        >
         <div class="fan">
<van-checkbox   :disabled='checked3'  v-model="carr[i].carrs"></van-checkbox>
          </div>
          <div class="fans"
           @click="payments(v)">
 <img
            v-show="v.type==5 ||v.type==6"
            src="../../assets/2.png"
            alt=""
          >
          <img
            v-show="v.type==3"
            src="../../assets/12.png"
            alt=""
          >
          <img
            v-show="v.type==1"
            src="../../assets/wechat@2x.png"
            alt=""
          >
          <img
            v-show="v.type==2"
            src="../../assets/wweds.png"
            alt=""
          >
          <p>{{v.type_name}}</p>
          </div>
        
         
        </li>

      </ul>
    </div>
    <!-- v-show="uid==7360" -->
      <div    class="but">
        <van-button
          type="danger"
          size="large"
          @click="go1"
          :disabled='xar'
        >确定提交</van-button>
      </div>
    <div
      class="pay"
      v-show="payflag"
    >
      <div
        class="colse"
        @click="colse"
      >
        <van-icon name="cross" />
      </div>
      <img
        :src="img"
        alt=""
      >
    </div>
    <van-dialog v-model="show" title="" @confirm='con'>
  <div class="p">您已成功提交订单，请按选择的结算方式及时付款并提交打款凭证，或及时回复消息，以便我们尽快安排发货（{{n}}s）</div>
</van-dialog>
 <van-popup
      v-model="show1"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="mi">
        <van-field
       
        v-model="value"
      
        label="短信验证码"
        placeholder="请输入短信验证码"
       
      >
        <template #button>
          <van-button
            size="small"
            type="primary"
            native-type="button"
            @click="timego"
            :disabled="but"
          >{{ timetxt }}</van-button>
        </template>
      </van-field>
      <p style="color: red; font-size: 0.35rem;">短信验证码会发送到此账号的绑定手机上</p>
       

      </div>

      <div class="but">
        <van-button
          type="primary"
          size="large"
          @click="ok"
        >确认</van-button>
      </div>

    </van-popup>
    <van-dialog v-model="sshow" @confirm='goss' title="提示"  confirmButtonText="已阅读并同意">
  <p style="text-align: center;padding: 0.6rem 0;">请您先阅读并同意 <span style="color: red;" @click="onk">《货空间鲸信用服务协议》</span></p>
</van-dialog>
  </div>  
</template>
<script>
import Vue from 'vue'
import { NavBar, Icon,Dialog,Checkbox, CheckboxGroup,Button, Toast,Popup,Field} from 'vant'

Vue.use(NavBar).use(Icon).use(Dialog).use(CheckboxGroup).use(Checkbox).use(Button).use(Popup).use(Field)
export default {
  created () {
    // this.$route.query.sid
    // console.log(this.$route.query.order)
    this.axios.post('pay_type', { store_id: this.$route.query.sid }).then(res => {
      this.list = res.data.data
     this.list.forEach(v => {
        if (v.type == 1) {
          v.type_name = "微信扫码支付"
        } else if (v.type == 2) {
          v.type_name = "支付宝扫码支付"
        } else if (v.type == 3) {
          v.type_name = "线下转账"
        } else if (v.type == 6) {
          v.type_name = "扫码支付"
        } else if (v.type == 5) {
          v.type_name = "信用卡二维码"
        }  
                 this.carr.push({ carrs:false,type:v.type})       
      })
      this.axios.post('cardAndOffline', { store_id: this.$route.query.sid }).then(res => {
        // console.log(res)
        // console.log(this.list)
        if (res.data.data.length > 0) {
          this.list.push({ type_name: '线下转账', type: 3 })
          this.xia = res.data.data
        }
                 this.carr.push({ carrs:false,type:3})       
      }).catch(ref => { })
      this.axios.post('getPreAccount', { store_id: this.$route.query.sid }).then(res => {
        console.log(res)
        // console.log(this.list)
         this.yu=+res.data.data.pre_account_money
        if(this.yu<=0){
          this.checked1=true
        }
      }).catch(ref => { })
    }).catch(ref => { })
    this.axios.post('accountQuota', {}).then(res => {
      if (res.data.code == 200) { 
        this.yu2 = +res.data.data.shengyuedu
        this.m2=res.data.data.is_delete
      if(res.data.data.is_clear==0){}else{this.checked4=true}
      if( this.yu2>0){}else{this.checked4=true}
      } else {
        // this.yu2 = +res.data.data.shengyuedu

        this.checked4=true
  }
     
      }).catch(ref => { })
      this.uid=JSON.parse(localStorage.getItem('user')).id

      // console.log(this.yu)
  },
  data () {
    return {
      payflag: false,
      list: [],
      img: '',
      xia: [],
      checked:false,
      checked1:false,
      checked2:false,
      checked3:false,
      checked4:false,
      carr:[],
      yu:0,
      yu2:0,
      show:false,
      show1:false,
      sshow: false,
      m2:0,
      n:6,
      ti:'',
      value:'',
      uid:0,
      xar: true,
      b:0,
      but: false,
      timetxt: '发送验证码',
      time:60
    }
  },
  methods: {
    onClickLeft () {
      this.$router.push('orderList')
    },
    payments (v) {
      // console.log(v)
      this.xar=false

      if (v.type == 3) {
        this.$router.push({ name: 'transfer', params: { id: this.xia } })
      } else {
        this.img = v.logo
        this.payflag = true
      }

    },
    colse () {
      this.payflag = false
    },
    xarr () {
      this.xar=false

    },
    fan(v){
      this.xar=false
      if(this.checked){          
        if(this.yu>=this.$route.query.money){
          this.checked4=true
          this.checked3=true
          this.checked2=false
          this.carr.forEach(v=>{
            v.carrs=false
          })
          
        }

        
      }else{
          this.checked4=false
          this.checked3=false

      }
    },
    fan2 (v) {
      if (this.m2 == 2) {
          this.sshow=true
          return false
        }
      this.xar=false
console.log(this.checked2)
      if(this.checked2){          
        if (this.yu2 >= this.$route.query.money) {
          this.b=1
          this.checked3=true
          this.carr.forEach(v=>{
            v.carrs=false
          })
          
        }

        
      } else {
        this.b=0
          this.checked3=false

      }
    },
    se(){
Dialog.confirm({
  title: '',
  message: '确认使用预付余额支付',
}).then(() => {
    // on confirm
  })
  .catch(() => {
    // on cancel
  });
    },
    go1 () {
    
      if (this.checked2) {
        this.m2=1
         this.show1=true
      
    }else{
      this.go()
    }
    },
    ok(){
   
      this.go(1)

    },
     go(xy){
    // console.log(this.carr)
    var that=this
    console.log(this.checked)
   let a=0
   let c=0
    let ar=[]
       if (this.checked2) {
    

ar.push(8)
    }
       if (this.checked) {
  a=1
ar.push(7)
}

this.carr.forEach(v=>{
  if(v.carrs){
  ar.push(v.type)

  }
})
let fg=false
if(ar.length==1){
  ar.forEach(v=>{
  if(v==7){
    if(this.yu<this.$route.query.money){
      Toast('您的钱包账户余额不足，请同时附加其他结算方式')
      fg=true
    }   
  }
  if(v==8){

    if(this.yu2<this.$route.query.money){

      Toast('您的鲸信用可用额度不足，请同时附加其他结算方式')
      fg=true
    }
    }
})
}

  if(ar.indexOf(7)!=-1){
    if(ar.indexOf(8)!=-1){
      if(ar.length>2){

      }else{
 if(this.yu2+this.yu<this.$route.query.money){
        console.log(this.yu2+this.yu)

      Toast('您的鲸信用可用额度加钱包账户余额不足，请同时附加其他结算方式')
      fg=true
    }
      }
   
  }
  }
       if (fg) {
return
    }
    if(ar.length==0){
      ar = [3]
     
    }
    if(ar.indexOf(7)==-1){
      this.yu=0
    }else{
      this.yu=this.yu
    }
     if(ar.indexOf(8)==-1){
      // this.yu2=0
       }
       if(ar.indexOf(3)==-1){
      c=0
    }else{
      c=1
    }
       console.log(ar)
       // return false
    let asb=xy==1?1:this.b
      this.axios.post('changeOrderStatus', { orderId: this.$route.query.order,jiesuan_method:ar,yun_money:this.yu,xin_money:this.yu2,ye_f:a,xy_f:asb, xk_f:c ,code: this.value, source: 'hkjpay',}).then(res => {
        if (res.data.code == 200) {
          console.log(res)       
        this.show = true
        this.show1=false
      
    this.ti= setInterval(function(){
    that.n=that.n-1
    console.log(1)
    if(that.n==0){
      clearInterval(that.ti)
      that.$router.push('orderList')

    }
   },1000)
       }else{
      Toast(res.data.msg)

    }
    
       
      }).catch(ref => {
        Toast('提交异常')
      })
  },
  con(){
          this.$router.push('orderList')

    },
    timego () {
     
      this.axios.post('sendpaysmscode', { source: 'hkjpay',imgcode:'' }).then(res => {
       console.log(res)
       Toast('发送成功')
        this.but = true
        var timer = setInterval(() => {
          this.time--
          this.timetxt = '请' + this.time + '秒后发送'
          if (this.time === 0) {
            this.but = false
            clearInterval(timer)
            this.time = 60
            this.timetxt = '发送验证码'
          }
        }, 1000)

         }).catch(ref => { })
     

    },
    goss () {
      this.axios.post('upjxyaccdelstatus', { checkstatus: '1', }).then(res => {
        this.sshow = false
        this.m2=1

      }).catch(ref => { 
        this.sshow=false
          
         })
     
    },
    onk () {
      this.$router.push('agreement3')
    },
 
  },
 
}
</script>
<style lang="less" scoped>
.cashier {
  background-color: #f5f5f5;
  height: 100%;
}
.mi {
  // padding: 0.5rem; 
  text-align: center;

  p {
    font-size: 0.5rem;
    margin: 0.5rem;
  }
  input {
    height: 1rem;
    width: 70%;
    border-radius: 5%;
    font-size: 0.4rem;
  }
  margin-bottom: 1rem;
}
.top {
  background-color: #fff;
  padding-top: 1.8rem;
  width: 100%;
  height: 5.5rem;
  text-align: center;
  .img {
    text-align: center;
  }
  p {
    font-size: 0.4rem;
    line-height: 1rem;
    span {
      color: #a52333;
      font-size: 0.45rem;
    }
  }
  .money {
    padding-top: 0.2rem;
    // font-size: 0.5rem;
    span{
      font-size: 0.7rem;
    }
  }
}
.bottom {
  background-color: #fff;
  padding: 0.2rem;
  .title {
    font-size: 0.4rem;
    color: #333;
    border-bottom: 1px solid #dfdfdf;
    padding-bottom: 0.15rem;
  }
  .conten {
    
    li {
      height: 1.92rem;
      border-bottom: 1px solid #ccc;
      padding: 0.3rem;
      .fan{
        float: left;
        padding: 0.3rem;
      }
      img {
        width: 1.1rem;
        height: 1.1rem;
        display: block;
        float: left;
        // background-color: #f99;
      }
      p {
        float: left;
        // width: 100%;
        font-size: 0.426667rem;
        line-height: 1.3rem;
        padding-left: 0.5rem;
        span{
          
        }
      }
      .p2{
        line-height: 0.65rem;
        font-size: 0.4rem;
        // padding-right: 0.2rem;
        text-align: right;
        float: right;
      }
    }
  }
}
.p{
  padding: 0.5rem;
  font-size: 0.4rem;
}
.pay {
  position: fixed;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 10rem;
  // background-color: #f99;
  .colse {
    position: absolute;
    top: 0%;
    font-size: 0.9rem;
    right: 5%;
    color: #ccc;
  }
}
.but{
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
